import { Box, Flex } from '@chakra-ui/react'
import { useContext } from 'react'

import { AuthContext } from '../../../contexts/AuthContext'
import AxInstructionsContext from '../../../contexts/AxInstructionsContext'
import AX_INSTRUCTIONS_STATUS from '../../../enums/axInstructionsStatus'
import { Tick } from '../../Icons/default'

const StepIndicator = () => {
    const { kalviumKc } = useContext(AuthContext)
    const { store } = useContext(AxInstructionsContext)
    const StepBox = ({ step, index }) => {
        const getStyleProps = () => {
            let styleProps = {}

            if (step.status == AX_INSTRUCTIONS_STATUS.CURRENT) {
                styleProps = {
                    bg: 'tundora',
                    color: 'white',
                }
            } else if (step.status == AX_INSTRUCTIONS_STATUS.COMPLETED) {
                styleProps = {
                    bg: 'fruitsalad',
                    color: 'white',
                }
            } else {
                styleProps = {
                    bg: 'white',
                    color: 'mineshaft',
                }
            }

            return styleProps
        }

        return (
            <Flex
                h={12}
                w={12}
                border={'3px solid #333333'}
                justify={'center'}
                align={'center'}
                fontSize={'md'}
                mb={12}
                fontWeight={'extrabold'}
                {...getStyleProps()}
            >
                {step?.status === AX_INSTRUCTIONS_STATUS.COMPLETED ? (
                    <Tick />
                ) : (
                    index + 1
                )}
            </Flex>
        )
    }

    return (
        kalviumKc.isLoggedIn() && (
            <Box marginInlineStart={'-25px !important'}>
                {/* Create totalSteps number of boxes */}
                {store?.steps?.map((step, idx) => {
                    return <StepBox step={step} key={idx} index={idx} />
                })}
            </Box>
        )
    )
}

export default StepIndicator
